module.exports = __webpack_public_path__ + "img/zxfw.0da63036.png";